import Settings from './settings'

const URLS = {
    API: Settings.BASE_URL+'api',
    GET_LOGIN : Settings.BASE_URL+'dj-rest-auth/login/',
    GET_LOGOUT : Settings.BASE_URL+'dj-rest-auth/logout/',
    NOTIFICATION: {
        MAIN: Settings.BASE_URL+'api/notification',
        NOT_NOTIFIED_COUNT: Settings.BASE_URL+'api/notification/not_notified_count/',
        NOT_NOTIFIED_FIRST: Settings.BASE_URL+'api/notification/not_notified_first/',
        UPDATE: Settings.BASE_URL+'api/notification/',
    },
    LEAK: { 
        MAIN: Settings.BASE_URL+'api/leak',
        SELECT_DATA: Settings.BASE_URL+'api/leak/names_and_ids/',
        FILTER_BY_POLYGON: Settings.BASE_URL+'api/leak/filter_by_polygon/',
        IDS_AND_POSITION:  Settings.BASE_URL+'api/leak/ids_and_position/',
    },
    AOI: {
        MAIN: Settings.BASE_URL+'api/aoi',
    },
    PIPE: {
        MAIN: Settings.BASE_URL+'api/pipe',
    },
    OBSERVATION:{
        MAIN: Settings.BASE_URL+'api/observation/',
        PYRAMID_INFO: Settings.BASE_URL+'api/observation/pyramid_info/',
        METRICS: Settings.BASE_URL+'api/observation/metrics/',
        LEAK_AREA: Settings.BASE_URL+'api/observation/leak_area/',
    }
};
export default URLS;